import { Injectable } from '@angular/core';

import { OpeningSchedule } from '@spartacus/core';

import { CustomDeliveryMode, nshiftDetails, nshiftOpeningHourDetails, RelayPoint } from '../models';

@Injectable({
  providedIn: 'root'
})
export class NshiftMapper {
  toDeliveryModes(nshiftDetails: nshiftDetails): CustomDeliveryMode[] {
    const deliveryModes = [];
    nshiftDetails.options?.forEach((optionDetail) => {
      deliveryModes.push({
        code: optionDetail.genericKeyValues?.find((x) => x.key === 'carrierid')?.value,
        name: optionDetail.name,
        type: optionDetail.genericKeyValues?.find((x) => x.key === 'type')?.value,
        deliveryCost: {
          value: optionDetail.priceValue,
          formattedValue: optionDetail.priceDescription
        },
        description: optionDetail.description1,
        deliveryProvider: optionDetail.genericKeyValues?.find((x) => x.key === 'provider')?.value
      });
    });
    return deliveryModes;
  }

  toRelayPoints(nshiftDetails: nshiftDetails, deliveryModeCode: string): RelayPoint[] {
    const relayPoints = [];
    nshiftDetails.options
      ?.find((x) => x.genericKeyValues?.find((x) => x.key === 'carrierid')?.value === deliveryModeCode)
      ?.agents.forEach((agent) => {
        relayPoints.push({
          id: agent.id,
          city: agent.city,
          zipCode: agent.zipCode,
          street: agent.address1,
          name: agent.name,
          country: agent.country,
          displayName: agent.name,
          email: agent.email,
          geoPoint: {
            latitude: agent.mapLatitude,
            longitude: agent.mapLongitude
          },
          telephone: agent.phone,
          distanceKm: agent.distance,

          openingHours: this.mapToOpeningHours(agent.openingHourWeekdays)
        });
      });
    return relayPoints;
  }

  private mapToOpeningHours(nshiftOpeningHourWeekdays: nshiftOpeningHourDetails[]): OpeningSchedule {
    return {
      weekDayOpeningList: nshiftOpeningHourWeekdays.map((nshiftOpeningHour) => ({
        specialDayOpeningList: null,
        closed: nshiftOpeningHour.closed,
        weekDay: nshiftOpeningHour?.description || nshiftOpeningHour?.weekday,
        hours: nshiftOpeningHour.hours.map((hour) => ({
          openingTime: {
            formattedHour: hour.start,
            hour: parseInt(hour.start?.split(':')[0]),
            minute: parseInt(hour.start?.split(':')[1])
          },
          closingTime: {
            formattedHour: hour.stop,
            hour: parseInt(hour.stop?.split(':')[0]),
            minute: parseInt(hour.stop?.split(':')[1])
          }
        }))
      }))
    };
  }
}
